import { Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Meta} from "../../../../_models/meta";

@Component({
    selector: 'rubrica',
    standalone: false,
    templateUrl: 'rubrica.component.html',
    styleUrls: ['rubrica.component.scss']
})

export class RubricaComponent implements OnInit {

    displayedColumns = ['Meta', 'Criterio', 'LD', 'L', 'LP', 'NL', 'Evidencias'];
    rubrica: any[] = [];

    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
    }

    ngOnInit() {
        this.rubrica = this.data.rubrica;
    }
}
